{
  "title": "Service jobs",
  "changedMeanwhile": "Someone else changed this meanwhile. The latest is loaded: check it and try again.",
  "changedMeanwhileEdit": "Someone else changed this meanwhile. Load the latest to see their change, then make yours again.",
  "loadLatest": "Load the latest",
  "fieldInvalid": "Check this value.",
  "stage": {
    "AWAITING_VISIT": "Awaiting a visit",
    "SCHEDULED": "Scheduled",
    "IN_PROGRESS": "In progress",
    "NEEDS_VISIT": "Needs another visit",
    "TO_INVOICE": "Ready to invoice",
    "AWAITING_PAYMENT": "Awaiting payment",
    "DONE": "Done",
    "CANCELLED": "Cancelled"
  },
  "status": {
    "NEW": "Awaiting a visit",
    "SCHEDULED": "Scheduled",
    "IN_PROGRESS": "In progress",
    "PARTIALLY_COMPLETED": "Partially completed",
    "COMPLETED": "Completed",
    "CANCELLED": "Cancelled"
  },
  "visitStatus": {
    "SCHEDULED": "Scheduled",
    "ON_SITE": "On site",
    "IN_PROGRESS": "In progress",
    "FINISHED": "Finished",
    "CANCELLED": "Cancelled"
  },
  "outcome": {
    "FULL": "Fully completed",
    "PARTIAL": "Partially completed",
    "NONE": "No work completed"
  },
  "kind": {
    "INITIAL": "First visit",
    "FOLLOW_UP": "Follow-up visit",
    "PLANNED": "Planned visit",
    "plannedPart": "Planned visit, part {{n}}"
  },
  "billing": {
    "NOT_READY": "Not ready",
    "READY": "Ready to invoice",
    "PARTIALLY_INVOICED": "Partially invoiced",
    "FULLY_INVOICED": "Fully invoiced",
    "NO_VISIT_INVOICE": "Under contract"
  },
  "payment": {
    "NONE": "Not invoiced",
    "UNPAID": "Unpaid",
    "PARTIALLY_PAID": "Partially paid",
    "PAID": "Paid"
  },
  "money": {
    "invoiced": "Invoiced · {{payment}}",
    "partInvoiced": "Part invoiced · {{payment}}"
  },
  "priceApproval": {
    "NOT_REQUESTED": "Price not agreed",
    "AWAITING": "Awaiting the customer",
    "ACCEPTED": "Price agreed",
    "CHANGED": "Changes need agreement",
    "DECLINED": "Price declined"
  },
  "agreementStatus": {
    "AWAITING": "Awaiting",
    "ACCEPTED": "Accepted",
    "DECLINED": "Declined",
    "SUPERSEDED": "Superseded"
  },
  "agreementMethod": {
    "ON_SITE_SIGNED": "Signed on site",
    "ON_SITE_VERBAL": "Agreed on site (verbal)",
    "PHONE": "By phone",
    "MESSAGE": "By WhatsApp or message",
    "EMAIL": "By e-mail"
  },
  "followUpStatus": {
    "PENDING": "Awaiting approval",
    "APPROVED": "Approved",
    "RETURNED": "Returned",
    "WITHDRAWN": "Withdrawn"
  },
  "followUpReason": {
    "PARTS_NEEDED": "Parts needed",
    "MORE_TIME": "More time needed",
    "CUSTOMER_UNAVAILABLE": "Customer not available",
    "ACCESS_PROBLEM": "No access to the site",
    "OTHER": "Other reason"
  },
  "collectionStatus": {
    "REPORTED": "Awaiting verification",
    "VERIFIED": "Verified",
    "REJECTED": "Rejected"
  },
  "priority": {
    "URGENT": "Urgent",
    "HIGH": "High",
    "NORMAL": "Normal",
    "LOW": "Low"
  },
  "dayPart": {
    "ANY": "Any time",
    "MORNING": "Morning",
    "AFTERNOON": "Afternoon",
    "EVENING": "Evening"
  },
  "billingMode": {
    "CHARGEABLE": "Chargeable",
    "CONTRACT": "Under a maintenance contract"
  },
  "waiting": {
    "PARTS": "Waiting for parts",
    "CUSTOMER": "Waiting for the customer"
  },
  "indicators": {
    "overdue": "Overdue",
    "followUpPending": "Follow-up requested",
    "collectionsAwaiting_one": "{{n}} payment to verify",
    "collectionsAwaiting_other": "{{n}} payments to verify"
  },
  "window": {
    "anyTime": "Any time",
    "from": "from {{time}}"
  },
  "fields": {
    "number": "Job",
    "customer": "Customer",
    "site": "Service location",
    "contact": "On-site contact",
    "contactName": "Contact name",
    "contactPhone": "Contact phone",
    "issue": "Problem reported",
    "plannedVisit": "Planned visit",
    "requestedService": "Service requested",
    "priority": "Priority",
    "preferredDate": "Preferred date",
    "preferredDayPart": "Preferred time",
    "targetDate": "Complete by",
    "billingMode": "Billing",
    "contractReference": "Contract reference",
    "team": "Team",
    "lead": "Visit lead",
    "date": "Date",
    "startTime": "From",
    "endTime": "To",
    "duration": "Estimated duration",
    "notes": "Notes",
    "nextVisit": "Next visit",
    "visits": "Visits",
    "createdAt": "Opened",
    "item": "Item",
    "quantity": "Quantity",
    "unitPrice": "Unit price",
    "tax": "VAT",
    "total": "Total",
    "agreed": "Agreed",
    "done": "Done",
    "invoiced": "Invoiced",
    "remaining": "Remaining",
    "chargeable": "Chargeable",
    "covered": "Covered by the contract",
    "amount": "Amount",
    "method": "Method",
    "collectedOn": "Collected on",
    "collectedBy": "Collected by",
    "reference": "Reference",
    "invoice": "Invoice",
    "balance": "Balance",
    "receipt": "Receipt",
    "reason": "Reason",
    "remainingWork": "Work remaining",
    "proposedDate": "Proposed date",
    "preparation": "Preparation (parts, tools)",
    "approverName": "Customer’s name",
    "approverPhone": "Customer’s phone",
    "address": "Address",
    "area": "Area",
    "directions": "Directions",
    "mapUrl": "Map link",
    "siteName": "Location name"
  },
  "report": {
    "workPerformed": "Work performed",
    "findings": "Findings",
    "condition": "Condition of the equipment",
    "unresolved": "Unresolved issues",
    "recommendations": "Recommendations",
    "nextAction": "Next action",
    "acknowledgedBy": "Acknowledged by"
  },
  "units": {
    "minutes_one": "{{n}} minute",
    "minutes_other": "{{n}} minutes",
    "hours": "{{h}} h {{m}} min"
  },
  "visitLabel": "Visit {{sequence}}",
  "salesOff": {
    "title": "Sales is turned off for your company",
    "job": "Invoices and receipts are sales documents, so this job’s completed work can’t be invoiced, and payments can’t be recorded or verified, until Sales is turned back on. The work stays recorded.",
    "visit": "Completed work can’t be invoiced and payments can’t be recorded until Sales is turned back on. Everything you record on this visit is kept.",
    "tile": "Sales is off"
  },
  "errors": {
    "JOB_CANCELLED": "This job is cancelled.",
    "JOB_COMPLETED": "This job is completed.",
    "JOB_HAS_OPEN_VISIT": "A team is on site: finish the visit first.",
    "JOB_HAS_INVOICES": "The job has invoices: its billing can no longer change.",
    "JOB_HAS_UNBILLED_WORK": "Completed work is not invoiced yet: invoice it first, or mark those items covered (not chargeable).",
    "SITE_HAS_VISITS": "The job has a visit at this location: cancel a scheduled visit first; once visited, the job stays at its location.",
    "VISIT_OVERLAP": "The team or the visit lead has another visit at that time.",
    "VISIT_ATTENDED": "The team has started this visit: it can no longer be rescheduled or cancelled.",
    "VISIT_NOT_ATTENDED": "The team has not started this visit yet.",
    "VISIT_NOT_IN_PROGRESS": "Begin the work before recording what was done.",
    "VISIT_FINISHED": "This visit is finished; it stays as it happened.",
    "VISIT_CANCELLED": "This visit is cancelled.",
    "NOT_TEAM_MEMBER": "Only the visit’s team (or a service manager) can do this.",
    "LEAD_NOT_IN_TEAM": "The visit lead must be an active member of the team.",
    "TEAM_ARCHIVED": "That team is archived. Choose another team.",
    "PRICE_NOT_AGREED": "Record the customer’s price approval first.",
    "SCOPE_CHANGED": "The items changed since the price was shown. Review them and try again.",
    "NOTHING_TO_AGREE": "Add the chargeable items and their prices first.",
    "AGREEMENT_DECIDED": "This price approval is already decided.",
    "ITEM_INVOICED": "Part of this item is invoiced: its price stays as invoiced.",
    "ITEM_BELOW_DONE": "The quantity cannot go below what is done or invoiced.",
    "QUANTITY_EXCEEDS_REMAINING": "That is more than is left.",
    "NOTHING_TO_INVOICE": "Nothing completed is left to invoice.",
    "NOT_CHARGEABLE": "This item is covered: it is not invoiced.",
    "FOLLOW_UP_PENDING": "A follow-up request is already open for this job.",
    "FOLLOW_UP_REQUIRED": "This job was already visited: another visit comes from an approved follow-up request.",
    "VISIT_HAS_WORK": "Work is recorded on this visit: choose “Partially completed”.",
    "FOLLOW_UP_DECIDED": "This request is already decided.",
    "REPORT_INCOMPLETE": "The visit report is missing what the company requires (a photo or the customer’s acknowledgment).",
    "INVOICE_NOT_OF_JOB": "Choose one of this job’s invoices.",
    "INVOICE_NOT_POSTED": "That invoice is void.",
    "COLLECTION_EXCEEDS_BALANCE": "That is more than is still open on the invoice.",
    "COLLECTION_DECIDED": "This collection is already decided.",
    "RECEIPT_MISMATCH": "Choose a posted receipt of this customer that verifies no other collection.",
    "RECEIPT_NOT_ALLOCATED": "Choose a receipt allocated to this collection’s invoice for at least the amount collected.",
    "SALES_MODULE_OFF": "Sales is not enabled for your company: invoices and receipts are unavailable.",
    "SITE_NOT_OF_CUSTOMER": "Choose one of this customer’s service locations."
  },
  "discard": {
    "title": "Discard unsaved changes?",
    "body": "What you entered here will be lost.",
    "confirm": "Discard changes",
    "keep": "Keep editing"
  },
  "origin": {
    "REQUEST": "Request",
    "PLANNED": "Planned"
  },
  "visitPlaces_one": "{{n}} place",
  "visitPlaces_other": "{{n}} places",
  "availability": {
    "nextDays": "Next days for {{team}}",
    "earlier": "Earlier days",
    "later": "Later days",
    "today": "Today",
    "free": "Free",
    "visits_one": "{{n}} visit",
    "visits_other": "{{n}} visits",
    "off": "Day off",
    "holidayShort": "Holiday",
    "holidayLabel": "holiday: {{name}}",
    "holidayProvisional": "{{name}} (provisional)",
    "loadFailed": "The team’s visits could not be loaded.",
    "retry": "Try again",
    "past": "This date has passed.",
    "offDay": "{{day}} isn’t a working day for the company.",
    "holiday": "Holiday: {{name}}",
    "noVisits": "No other visits.",
    "reasons": "Common reasons",
    "reason": {
      "customer": "Customer asked",
      "team": "Team not available",
      "parts": "Waiting for parts",
      "access": "No access or weather"
    },
    "reasonText": {
      "customer": "The customer asked to move the visit.",
      "team": "The team is not available then.",
      "parts": "Waiting for parts before the visit.",
      "access": "No access to the site, or the weather stopped the work."
    }
  }
}
